import React, { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Modal from 'react-modal';
import { observer } from 'mobx-react';
import { enableBodyScroll, disableBodyScroll } from "body-scroll-lock"
import useModalStore from '../../../hooks/useModalStore';
import useUsersStore from '../../../hooks/useUsersStore';
import { FORBIDDEN_MESSAGES, UNAUTHORIZED_MESSAGES } from '../../../common/services/api';

Modal.setAppElement('#root');

const AlertModal = observer(forwardRef(({ option }, ref) => {
  const modalRef = useRef()
  useImperativeHandle(ref, () => modalRef.current, [modalRef])
  const usersStore = useUsersStore();
  const modalStore = useModalStore();

  const isOpen = option?.isOpen;

  useEffect(() => {
    if (!isOpen) {
      enableBodyScroll(modalRef.current)
    } else {
      disableBodyScroll(modalRef.current)
    }
  }, [isOpen])

  if (!option || !option.message) {
    return null;
  }
  const dismissible = option && option?.message && option.message === FORBIDDEN_MESSAGES.PREVENT_ADMIN_ACCESS ? false : option.dismissible;

  return   (
    <Modal
      ref={modalRef}
      isOpen={option.isOpen}
      onRequestClose={() => {
        if (option.dismissible) modalStore.closeModal();
      }}
      shouldCloseOnOverlayClick={dismissible}
      shouldCloseOnEsc={dismissible}
      style={{
        content: {
          top: '40%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)'
        }
      }}
      overlayClassName="modal_overlay"
    >
      <div className="alert" ref={ref}>
        <div style={{ marginBottom: 8 }}>
          <h2>{option.title}</h2>
        </div>
        <div style={{ textAlign: 'center' }}>
          <ul>
            {option.message.split('\n').map((value, key) => {
              return (
                <li key={key}>
                  <span>{value}</span>
                </li>
              );
            })}
          </ul>
        </div>
        <div>
          <button
            onClick={() => {
              // If the message is one of the UNAUTHORIZED_MESSAGES, redirect to the login page.
              if (option && option?.message && UNAUTHORIZED_MESSAGES.includes(option.message)) {
                window.location.href = '/auth/login';
              }
              if (option && option?.message && option.message === FORBIDDEN_MESSAGES.PREVENT_ADMIN_ACCESS) {
                usersStore.logout(() => {
                  window.location.href = '/home';
                });
              }
              modalStore.closeModal();
            }}
          >
            확인
          </button>
        </div>
      </div>
    </Modal>
  );
}));

export { AlertModal };
